import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/common/Navbar';
import Sidebar from '@/components/common/Sidebar';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true); // Default to open for better UX

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar 
        onMenuClick={() => setSidebarOpen(!sidebarOpen)} 
      />
      <div className="flex">
        <Sidebar 
          isOpen={sidebarOpen} 
          onToggle={() => setSidebarOpen(!sidebarOpen)} 
        />
        <main className={`flex-1 p-6 transition-all duration-300 ${
          sidebarOpen ? 'ml-0' : 'ml-0'
        }`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
